goog.provide("shadow.js.shim.module$$tiptap$extension_italic");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_italic");
shadow.js.shim.module$$tiptap$extension_italic = shadow.js.nativeProvides["@tiptap/extension-italic"] = shadow$bridge("@tiptap/extension-italic");
module$shadow_js_shim_module$$tiptap$extension_italic.default = shadow.js.shim.module$$tiptap$extension_italic;
